export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14058.1c624ee3.jpg";